import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import './styles/global.css';
import './styles/spotify-theme.css';
import { BrowserRouter as Router } from 'react-router-dom';



const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);